import React from "react";
import styles from "./PageHelperModal.module.scss";
import PageHelperTrigger from "./PageHelperTrigger";

type Props = {
  handleHelpModal: () => void;
  helpTitle: string;
  helpText: string;
};

const PageHelperModal: React.FC<Props> = (props) => {
  const { handleHelpModal, helpTitle, helpText } = props;

  return (
    <div className={styles["page-helper"]}>
      <div className={styles["page-helper-content"]}>
        <PageHelperTrigger
          handleHelpModal={handleHelpModal}
          buttonText="CLOSE"
        />
        <div className={styles["page-helper_box"]}>
          <div className={styles["page-helper_title"]}>{helpTitle}</div>
          <p className={styles["page-helper_message"]}>{helpText}</p>
        </div>
      </div>
    </div>
  );
};

export default PageHelperModal;
